import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { View } from 'react-native'
import {
  VFButton,
  Icon,
  VFScreen,
} from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import BundleList from '../../Components/BundleList/BundleList'

import images from '../../Themes/Images'
import VfText from '../../Components/VfText'
import Modal from '../../Components/Modal'

import styles from './Bundles.Styles'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const MODAL_TYPES = {
  success: 'success',
  proccessing: 'proccesssing',
  error: 'error',
  idError: 'idError',
}

function Bundles({
  selectedOffer,
  setSelectedOffer,
  offers,
  onClose,
  isPurchase,
  resetStatusBar,
  onSelectOffer,
  isContentLoading,
  error,
  errorMessage,
  theme,
}) {
  const insets = useSafeAreaInsets()

  /** Success and Error Modal */
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    type: 'normal',
  })
  const [modalState, setModalState] = useState({
    loading: false,
    type: null,
    title: null,
    desc: null,
    backLabel: null,
    back: null,
    backLoading: false,
    retryLabel: null,
    retry: null,
    retryLoading: false,
  })


  const closeModal = () => {
    setModalState({
      loading: false,
      type: null,
      title: null,
      desc: null,
      backLabel: null,
      back: null,
      backLoading: false,
      retryLabel: null,
      retry: null,
      retryLoading: false,
    })
    setModalProps({
      isOpen: false,
      type: 'normal',
    })
  }

  useEffect(() => {
    resetStatusBar()
  }, [])

  useEffect(() => {
    setModalState({
      loading: isContentLoading,
      type: 'error',
      title: errorMessage || 'Something went wrong!',
      desc: errorMessage || 'Something went wrong!',
      backLabel: 'Go Back',
      back: onClose,
      backLoading: false,
      retryLabel: null,
      retry: null,
      retryLoading: false,
    })
    setModalProps({
      isOpen: error,
      type: 'full',
    })
  }, [error, isContentLoading])

  const renderModalContent = () => {
    let icon
    if (modalState.type === MODAL_TYPES.error) {
      icon = images.warning
    } else {
      icon = images.tick
    }

    if (modalState.loading) {
      return null
    }
    if (!modalState.type) {
      return null
    }

    return (
      <View style={styles.modalContentContainerWraper}>
        <View style={styles.modalContentWraper2}>
          <Icon name={icon} size={54} type="image" resizeMode="contain" />
          <VfText
            weight="bold"
            size="h2"
            align="center"
            style={styles.verticalSpacing}
            i18nKey={modalState.title}
          />
          <VfText
            align="center"
            size="h5"
            i18nKey={modalState.desc}
          />
        </View>
        <VFButton
          type="primary"
          title={modalState.backLabel || 'renewal_close_modal'}
          onPress={() => modalState.back ? modalState.back() : closeModal()}
          disabled={modalState.backLoading || modalState.retryLoading}
          isLoading={modalState.backLoading}
          loadingTitle="renewal_processing_action"
        />
        {modalState.retry && (
          <VFButton
            type="secondary"
            title={modalState.retryLabel || 'renewal_try_again'}
            onPress={modalState.retry}
            style={styles.secondaryButton}
            disabled={modalState.backLoading || modalState.retryLoading}
            isLoading={modalState.retryLoading}
            loadingTitle="renewal_processing_action"
          />
        )}
      </View>
    )
  }

  return (
    <VFScreen
      title="renewals_bundle_offer"
      withSubHeader
      subHeaderTitle="renewals_bundles_subtitle"
      onClose={onClose}
      headerStyle={styles.headerStyle}
      titleStyle={styles.headerTexts}
      subHeaderTitleStyle={styles.headerTexts}
      rightIcon={images.close_white}
      withHeaderSpace
    >
      <BundleList
        selectedOffer={selectedOffer}
        setSelectedOffer={setSelectedOffer}
        offers={offers}
        showHeader={isPurchase}
        isPurchase={isPurchase}
        bundleProps={{
          onButtonPress: onSelectOffer,
        }}
        isLoading={isContentLoading}
        theme={theme}
      />
      <Modal
        visible={modalProps.isOpen}
        close={() => {
          modalState.back?.()
          closeModal()
        }}
        type={modalProps.type}
        contentContainerStyle={styles.modal}
        insets={insets}
        theme={theme}
      >
        {renderModalContent()}
      </Modal>
    </VFScreen>
  )
}

Bundles.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors,
  }
}

Bundles.propTypes = {
  selectedOffer: PropTypes.number,
  setSelectedOffer: PropTypes.func,
  offers: PropTypes.array,
  onClose: PropTypes.func,
  onSelectOffer: PropTypes.func,
  isPurchase: PropTypes.bool,
  resetStatusBar: PropTypes.func,
}

export default withTheme(Bundles)
